import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

import { paginationDropdownOptions } from 'constants/dropdownOptions';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { createAutomationRule, getAutomationRules } from 'services/Settings';
import { handlePageNumberInPagination } from 'common/pagination';
import { toastConstant } from 'constants/toastmessage';
import { useToast } from 'context/ToastContext';
import { updateWorkFlowAutomationRules } from 'services/workflowAutomation/workflowAutomationRuleServices';
import { validateAutomationRule } from 'services/settings/workflowAutomation/workflowAutomationServices';

export default function useAutomationList(_pageSize = 10, filter = {}) {
  const userDetails = useUserDetailsContext();
  const { addToast } = useToast();

  const [data, setData] = useState([]);
  const [isForward, setIsForward] = useState(true);
  const [pageSize, setpageSize] = useState(userDetails?.firmDetails?.pagination_preference?.automation?.self ?? 10);
  const [conflictErrorData, setConflictErrorData] = useState(null);

  const next_Token = data?.next_token;
  const transition_Token = data?.transition_token;
  const automationList = data?.['automation_rules'] || [];

  const hasNext = next_Token === null && isForward;
  const hasPrevious = transition_Token === null || (transition_Token && next_Token === null && !isForward);

  const fetchNext = () => {
    setIsForward(true);
    loadAutomationList(pageSize, !isForward ? transition_Token : next_Token, 'forward');
  };

  const fetchprev = () => {
    setIsForward(false);
    loadAutomationList(pageSize, !isForward ? transition_Token : next_Token, 'reverse');
  };

  const onPageChange = (e) => {
    console.log(e.value);
    setpageSize(e.value);
    loadAutomationList(e.value, '', 'forward');
    setIsForward(false);
    handlePageNumberInPagination(userDetails, 'automation', '', 'self', e.value);
  };

  const paginatorTemplate = {
    layout: 'RowsPerPageDropdown PrevPageLink NextPageLink',
    RowsPerPageDropdown: () => {
      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--black-500)', userSelect: 'none' }}>
            Item Per Page
          </span>
          <Dropdown value={pageSize} options={paginationDropdownOptions} onChange={onPageChange} />
        </React.Fragment>
      );
    },
    NextPageLink: ({ iconClassName }) => {
      return (
        <Button onClick={fetchNext} disabled={hasNext} className={'p-paginator-next p-paginator-element p-link'} icon={iconClassName} />
      );
    },
    PrevPageLink: ({ iconClassName }) => {
      return (
        <Button onClick={fetchprev} disabled={hasPrevious} className={'p-paginator-next p-paginator-element p-link'} icon={iconClassName} />
      );
    },
  };

  const loadAutomationList = (pageLimit, pagination_token, pagination_direction) => {
    getAutomationRules(null, filter?.practice_area, filter?.automation_status, pageLimit, pagination_token, pagination_direction)
      .then((response) => setData(response?.data))
      .catch((error) => console.log(error));
  };

  const handleDuplicateAutomationRule = (rowData) => {
    const { sk } = rowData || {};
    if (sk) {
      createAutomationRule({}, `automation_sk_to_duplicate=${sk}`)
        .then(() => {
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, 'Automation rule duplicated successfully');
          loadAutomationList(pageSize, '', 'forward');
        })
        .catch((error) => {
          console.log('error duplicating automation rule', error);
          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, 'Failed to duplicate automation rule');
        });
    }
  };

  const updateStatus = async (rowData) => {
    let data = { sk: rowData?.sk, pk: rowData?.pk };
    if (rowData?.automation_status === 'ACTIVE') {
      data.automation_status = 'INACTIVE';
    } else {
      try {
        await validateAutomationRule({
          data: { validation_action_code: rowData?.validation_action_code, validation_trigger_code: rowData?.validation_trigger_code },
        });
      } catch (error) {
        const { data } = error?.response || {};
        setConflictErrorData(data?.conflicting_rule_triggers || null);
        return;
      }
      data.automation_status = 'ACTIVE';
    }
    updateWorkFlowAutomationRules(false, data)
      .then(() => {
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.WORKFLOW_STATUS_UPDATE_SUCCESS);
        loadAutomationList(pageSize, '', 'forward');
      })
      .catch(() => {
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.WORKFLOW_STATUS_UPDATE_FAILED);
      });
  };

  useEffect(() => {
    loadAutomationList(pageSize, '', 'forward');
  }, [filter]);

  return {
    paginatorTemplate,
    automationList,
    pageSize,
    handleDuplicateAutomationRule,
    conflictErrorData,
    setConflictErrorData,
    updateStatus,
  };
}
